export default {
  methods: {
    /**
     * Muestra mensajes de notificaciones
     * @param message
     * @param alertType (is-white|is-black|is-light|is-dark|is-primary|is-info|is-success|is-warning|is-danger)
     */
    alert({
      message,
      alertType = 'is-warning',
      duration = 3000,
      hasIcon = true
    }) {
      this.$buefy.notification.open({
        duration,
        message,
        type: alertType,
        hasIcon
      });
    }
  }
};
